'use strict';

angular.module('ClinicApp').controller('ClinicSignBAACtrl', function($modalInstance, $scope, clinic, ClinicService, SignableDocumentsConstants, CurrentUser) {
  $scope.clinic = clinic;
  $scope.user = CurrentUser.getUser();

  $scope.signDocuments = function() {
    ClinicService.signDocuments($scope.signableDocuments);
    $modalInstance.close();
  };

  $scope.init = function() {
    var country = _.get($scope.user, 'editable.clinics[0].address.country', 'United States');
    $scope.signableDocuments = SignableDocumentsConstants[country];
  };
});
